import { SearchQuery } from "shared/data/reducers/types/storage";
import FlightOffer from "shared/types/flightOffer";

import { isDefaultSelectedFilterMatch } from "../defaultSelectedFilters";

const filterFromTo = (searchQuery: SearchQuery) => (
  flightOffer: FlightOffer
) => {
  if (
    !isDefaultSelectedFilterMatch(
      searchQuery.airports_from,
      flightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
        .FlightSegment[0].OriginAirport
    )
  ) {
    return false;
  }

  if (searchQuery.airports_to) {
    const destinationAirport =
      flightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
        .FlightSegment[
        flightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
          .FlightSegment.length - 1
      ].DestinationAirport;

    if (
      !isDefaultSelectedFilterMatch(searchQuery.airports_to, destinationAirport)
    ) {
      return false;
    }
  }

  return true;
};

export default filterFromTo;
